import React from "react";

const EventSiapaTsunami = () => {
  return (
    <div className="xl:text-xl md:text-lg text-base leading-loose px-2 sm:px-0">
      <p>
        KBRN, Meulaboh: Berbagai cara dan kegiatan dilakukan masyarakat dalam
        rangka memperingati 19 tahun gempa dan tsunami Aceh. Seperti giat tim
        edukasi ceria membuat event edukasi dengan tema "Siapa Tsunami" Selasa
        (26/12/2023).
      </p>
      <p className="mt-4">
        Kegiatan tersebut berlangsung di lokasi praktik Edukasi Ceria/Psikolog
        yang beralamat di jalan Purnama, Lorong Cut Ali, Meulaboh, Kabupaten
        Aceh Barat. Peserta dalam kegiatan ini terdiri dari 30 Anak yang berusia
        5-12 tahun.
      </p>
      <p className="mt-4">
        Dalam pelaksanaan kegiatan tersebut rangkaian acara terdiri dari Cerita
        Tsunami Aceh/Story Telling, Eksperimen Sains Tsunami dan Kesiapsiagaan
        Bencana Tsunami serta Melatih Regulasi Emosi dan Praktik Pembuatan
        Pelampung Darurat. Kegiatan tersebut di pandu oleh Ria Handita selaku
        psikolog.
      </p>
      <p className="mt-4">
        Paling menarik dari kegiatan ini yaitu terletak pada bagian eksperimen
        tsunami, dimana alat dan bahan yang digunakan dapat dimainkan langsung
        oleh anak-anak. Serta anak-anak juga di ajak menonton beberapa cuplikan
        video tsunami Aceh 2004 untuk memberikan gambaran bagaimana tsunami pada
        saat itu melanda Aceh.
      </p>
      <p className="mt-4">
        "Tujuan dari kegiatan ini untuk melatih regulasi emosi anak-anak pasca
        tsunami, serta melatih anak-anak untuk siap siaga jika terjadi tsunami,
        model edukasi yang diberikan juga sangat santai dan menyenangkan karena
        di sajikan dengan permainan yang interaktif," Kata Ria Handita.
      </p>
      <p className="mt-4">
        Kegiatan edukasi ceria tersebut dirancang untuk menambah pemahaman
        anak-anak di usia 5-12 tahun agar paham bagaimana cara atau langkah
        mitigasi bencana saat darurat dan cara mengatur kembali emosi agar tetap
        stabil.
      </p>
      <p className="mt-4">
        "Kegiatan ini kita buat sedemikian rupa agar anak-anak paham cara
        mitigasi bencana, dan dapat mengatur atau mengontrol emosi nya, dalam
        pelaksanaan ini selain kita bercerita, eksperimen dan membuat pelampung
        darurat," sebutnya lagi.
      </p>
      <p className="mt-4">
        Metode yang digunakan juga melalui praktik melindungi diri saat terjadi
        gempa dan tsunami melalui lirik lagu siap siaga tsunami. Tujuannya agar
        anak-anak lebih paham dan mudah mengingat langkah-langkah apa saja yang
        harus dilakukan. (Haris Nanda Lubis).
      </p>
      <p className="mt-4">
        "Harapan nya, dalam rangka memperingati 19 tahun tsunami Aceh semoga
        dari kegiatan ini anak-anak dapat mengambil pelajaran agar dapat bersiap
        dalam menyikapi bencana tsunami dan orang tua lebih peduli terhadap
        emosi anak ketika terjadi bencana" Tutup nya.
      </p>
      <p className=" mt-4">Source: </p>
      <a
        href="https://www.rri.co.id/meulaboh/daerah/493797/tim-edukasi-ceria-gelar-event-memperingati-19-tahun-tsunami"
        className=" text-blue-700 hover:opacity-60"
      >
        https://www.rri.co.id/meulaboh/daerah/493797/tim-edukasi-ceria-gelar-event-memperingati-19-tahun-tsunami
      </a>
    </div>
  );
};

export default EventSiapaTsunami;
